module.exports = __webpack_public_path__ + "static/Avenir Black-275de2221d9f0c4c9257d17f5a1e4006.ttf";